import { useContext, useEffect, useState } from "react"
import AOS from 'aos';
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import OneClient from "../ones/OneClient";

// Import Partner Logos (Ensure these paths match your folder structure)
import NMBLogo from "../assets/nmb.png";
import MaendeleoLogo from "../assets/maendeleo.png";
import KeplerLogo from "../assets/kepler.png";
import BrainPowerLogo from "../assets/brain.png";
import StrategicLogo from "../assets/agility.png";
import OasisLogo from "../assets/oasis.png";

export default function ClientsBanner(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const partners = [
    { name: "NMB Bank PLC", logo: NMBLogo },
    { name: "Maendeleo Bank PLC", logo: MaendeleoLogo },
    { name: "Kepler Consultant", logo: KeplerLogo },
    { name: "BrainPower Consultants", logo: BrainPowerLogo },
    { name: "Strategic Agility Consulting", logo: StrategicLogo },
    { name: "OASIS Financial Services Limited", logo: OasisLogo },
  ];

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllClients(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  if (ready) {
    return (
      <div 
        className="MainBodySection bg-background text-primary"
        style={{
          paddingTop: "80px",
          paddingBottom: "80px",
          background: "linear-gradient(180deg, rgba(241,245,249,1) 0%, rgba(255,255,255,1) 100%)"
        }}
      >
        <div className="container">
          <div className="row">
            
            {/* TRUSTED PARTNERS SECTION */}
            <div className="col-md-12 mb-5 text-center" data-aos="fade-up">
              <span 
                className="section-subtitle font-semi-bold mb-4 d-block text-primary fs-3 text-uppercase"
                style={{ 
                  letterSpacing: "2.5px", 
                  fontSize: "0.85rem",
                  color: "#3b82f6",
                  fontWeight: "700"
                }}
              >
                TRUSTED PARTNERS
              </span>
              
              <div className="row justify-content-center align-items-center g-4 mt-2">
                {partners.map((partner, index) => (
                  <div key={index} className="col-6 col-md-4 col-lg-2">
                    <div className="partner-logo-wrapper p-3">
                      <img 
                        src={partner.logo} 
                        alt={partner.name} 
                        className="img-fluid partner-logo"
                        style={{
                          maxHeight: "60px",
                          transition: "all 0.3s ease-in-out"
                        }}
                        title={partner.name}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* SEPARATOR */}
            <div className="col-12 my-5">
               <hr style={{ opacity: '0.1' }} />
            </div>

            {/* OUR CLIENTS SECTION */}
            <div className="col-md-12 text-center" data-aos="fade-up">
              <span 
                className="section-subtitle font-semi-bold mb-5 d-block text-primary fs-3 text-uppercase"
                style={{ 
                  letterSpacing: "2.5px", 
                  fontSize: "0.85rem",
                  color: "#3b82f6",
                  fontWeight: "700"
                }}
              >
                OUR CLIENTS
              </span>

              <div className="row g-4 justify-content-center">
                {(() => {
                  const isHomePage = appContext.navItem === "" || appContext.navItem === "home";
                  const displayedClients = isHomePage ? (appContext.allClients || []).slice(0, 3) : (appContext.allClients || []);
                  
                  if (displayedClients.length > 0) {
                    return displayedClients.map((item, i) => (
                      <div 
                        key={i} 
                        className="col-md-4"
                        data-aos="fade-up" 
                        data-aos-delay={i * 150}
                      >
                        <OneClient data={item}/>
                      </div>
                    ));
                  }
                })()}
              </div>
            </div>
            
          </div>
        </div>

        <style jsx>{`
          .partner-logo-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100px;
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            transition: transform 0.3s ease;
          }
          .partner-logo-wrapper:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          }
        `}</style>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading" style={{ paddingTop: "60px", paddingBottom: "60px" }}>
        {getInlineLoader()}
      </div>
    );
  }
}